import AddressInput from '@/components/DSE/AddressInput';
import CrudStockLocation from '../components/CrudStockLocation';
import FileUpload from '@/components/DSE/FileUpload';
import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import { validatorEmail, validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, true, false], // Tab 1, tab 2, ....
    labels: ['common.tabGeneral', 'company.exact', 'common.stockLocations'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.name || ''}
    </h3>
    `,
    groups: [
      {
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        description: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 255
          }
        },
        invoiceAddress: {
          type: AddressInput,
          defaultValue: null,
          props: {
            caption: 'common.address',
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        companyEmail: {
          type: MDinput,
          props: {
            type: 'email',
            maxlength: 64
          },
          rules: [{ validator: validatorEmail }]
        },
        phone: {
          type: MDinput,
          props: {
            type: 'tel'
          }
        },
        bankName: {
          type: MDinput,
          props: {
            maxlength: 32
          }
        },
        bankAccountBIC: {
          type: MDinput,
          props: {
            maxlength: 11
          }
        },
        iban: {
          type: MDinput,
          props: {
            maxlength: 34
          }
        },
        businessRegisterNumber: {
          type: MDinput,
          props: {
            maxlength: 16
          }
        },
        bdo: {
          type: MDinput,
          props: {
            maxlength: 9
          }
        },
        currencyID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.currency',
            required: true,
            valueField: 'id',
            labelField: 'description',
            loading: vue.$store.getters['currency/isLoading'],
            options: vue.$store.getters['currency/loadedItems']
          },
          rules: [{ validator: validatorRequire }]
        },
        vatNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        debtorNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'common.debtorNumber',
            maxlength: 18
          }
        },
        creditorNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'common.creditorNumber',
            maxlength: 18
          }
        },
        fiscalUnitCompanyID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'company.fiscalUnit',
            required: true,
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['company/isLoading'],
            options: vue.$store.getters['company/loadedItems']
          }
        },
        remarkInvoice: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 255,
            caption: 'company.remarkInvoice'
          }
        },
        intrastatReportingYN: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'company.intrastatReporting',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        mailingAddress: {
          type: AddressInput,
          defaultValue: null,
          props: {
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        globalLocationNumber: {
          type: MDinput,
          defaultValue: null,
          props: {
            maxlength: 13
          }
        },
        logoFileName: {
          type: FileUpload,
          defaultValue: null,
          hideOnCreate: true,
          props: {
            hideOnCreate: true,
            caption: 'company.logo',
            uploadRoute: 'company/logo',
            deleteAction: 'company/deleteLogo',
            downloadAction: 'company/downloadLogo'
          }
        }
      },
      {
        // Tab 2: Exact
        exactInstanceID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.exactInstance',
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['exactInstance/isLoading'],
            options: vue.$store.getters['exactInstance/loadedItems']
          }
        },
        administrationNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 3,
            caption: 'company.administrationNumber'
          }
        },
        clientSalesJournalCode: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 3,
            caption: 'company.clientSalesJournalCode'
          }
        },
        intercompanySalesJournalCode: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 3,
            caption: 'company.intercompanySalesJournalCode'
          }
        },
        salesJournalType: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 1,
            caption: 'company.salesJournalType'
          }
        },
        purchaseJournalCode: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 3,
            caption: 'company.purchaseJournalCode'
          }
        },
        purchaseJournalType: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 1,
            caption: 'company.purchaseJournalType'
          }
        }
      },
      {
        // Tab 3: Stock locations
        stockLocations: {
          type: CrudStockLocation,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'companyID',
            permissionCode: 'Company'
          }
        }
      }
    ]
  };
}
const layoutFullWidth = {
  sections: [
    {
      width: 100
    }
  ]
};

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 50,
      fields: [
        'name',
        'description',
        'companyEmail',
        'phone',
        'bankName',
        'bankAccountBIC',
        'iban',
        'businessRegisterNumber',
        'bdo',
        'currencyID',
        'vatNumber',
        'fiscalUnitCompanyID',
        'remarkInvoice',
        'intrastatReportingYN',
        'logoFileName'
      ]
    },
    {
      width: 50,
      fields: ['mailingAddress', 'invoiceAddress', 'globalLocationNumber']
    }
  ]
};

const layoutTabExact = {
  named: true,
  sections: [
    {
      width: 50,
      fields: [
        'exactInstanceID',
        'administrationNumber',
        'clientSalesJournalCode',
        'intercompanySalesJournalCode',
        'salesJournalType',
        'purchaseJournalCode',
        'purchaseJournalType',
        'debtorNumber',
        'creditorNumber'
      ]
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutTabExact]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutTabExact, layoutFullWidth]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
